import {
    InsuranceService,
    LeadsService,
    UtilityService,
} from "./services";

export class ServiceProxy {
    InsuranceService;
    LeadsService;
    UtilityService;
    constructor(_apiUrl) {
        this._apiUrl = _apiUrl
        this.InsuranceService = new InsuranceService(this._apiUrl);
        this.LeadsService = new LeadsService(this._apiUrl);
        this.UtilityService = new UtilityService(this._apiUrl);
    }
}